<app-breadcrumb [title]="'user profile'|translate" [items]="['security'|translate]" [active_item]="'user profile'|translate"></app-breadcrumb>
<div class="container-fluid">
  <div class="edit-profile">
    <form class="row" [formGroup]="userForm" (ngSubmit)="onFormSubmit()" id="ngForm">
      <div class="col-xl-4">
        <div class="card">
          <div class="card-header">
            <h5 class="card-title mb-0 f-w-700">{{ 'picture'|translate }}</h5>

            <ng-template *ngIf="loadForm === false; else isLoadForm"> </ng-template>
            <ng-template #isLoadForm>
              <div class="card-header-right">
                <ul class="list-unstyled card-option">
                  <li><i class="fa fa-spin fa-cog"></i></li>
                </ul>
              </div>
            </ng-template>

            <div class="card-options">
              <a class="card-options-collapse" href="javascript:void(0)" data-bs-toggle="card-collapse"><i class="fe fe-chevron-up"></i></a><a class="card-options-remove" href="javascript:void(0)" data-bs-toggle="card-remove"><i class="fe fe-x"></i></a>
            </div>
          </div>
          <div class="card-body">
            <div>
              <div class="row mb-2">
                <div class="col-auto">
                  <img class="img-70 rounded-circle" alt="" src="{{defaultImg}}" />
                </div>
                <div class="col">
                  <h5 class="mb-1">{{userName}}</h5>
                  <p class="mb-4">{{profileName}}</p>
                </div>
              </div>

              <div class="col-md-12 mb-3">
                <label class="form-label">{{ 'picture'|translate }} </label>
                <input class="form-control form-control-sm" type="file" (change)="onChange($event)" formControlName="file" [ngClass]="{'is-invalid': fc['file'].invalid && isSubmitted}">
                <div class="invalid-feedback" *ngIf="fc['file'].errors?.['serverError']">
                  {{ fc['file'].errors?.['serverError'] }}
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-8">
        <div class="card" >
          <div class="card-header">
            <h5 class="card-title mb-0 f-w-700">{{ 'profile'|translate }}</h5>

            <ng-template *ngIf="loadForm === false; else isLoadForm"> </ng-template>
            <ng-template #isLoadForm>
              <div class="card-header-right">
                <ul class="list-unstyled card-option">
                  <li><i class="fa fa-spin fa-cog"></i></li>
                </ul>
              </div>
            </ng-template>

            <div class="card-options">
              <a class="card-options-collapse" href="javascript:void(0)" data-bs-toggle="card-collapse"><i class="fe fe-chevron-up"></i></a><a class="card-options-remove" href="javascript:void(0)" data-bs-toggle="card-remove"><i class="fe fe-x"></i></a>
            </div>
          </div>
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4">
                <label class="form-label">{{ 'firstname'|translate }} <span class="text-danger">*</span></label>
                <input class="form-control form-control-sm" type="text" placeholder="Ex. John" formControlName="firstname" [ngClass]="{'is-invalid': fc['firstname'].invalid && isSubmitted}">
                <small class="invalid-feedback fst-italic" *ngIf="fc['firstname'].errors?.['required']">{{ 'this field is required'|translate }}</small>
                <div class="invalid-feedback" *ngIf="fc['firstname'].errors?.['minlength']">{{ 'firstname must be at least 3 characters long'|translate }}</div>
                <div class="invalid-feedback" *ngIf="fc['firstname'].errors?.['serverError']">
                  {{ fc['firstname'].errors?.['serverError'] }}
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-label">{{ 'lastname'|translate }} <span class="text-danger">*</span></label>
                <input class="form-control form-control-sm" type="text" placeholder="Ex. Doe" formControlName="lastname" [ngClass]="{'is-invalid': fc['lastname'].invalid && isSubmitted}">
                <small class="invalid-feedback fst-italic" *ngIf="fc['lastname'].errors?.['required']">{{ 'this field is required'|translate }}</small>
                <div class="invalid-feedback" *ngIf="fc['lastname'].errors?.['minlength']">{{ 'lastname must be at least 3 characters long'|translate }}</div>
                <div class="invalid-feedback" *ngIf="fc['lastname'].errors?.['serverError']">
                  {{ fc['lastname'].errors?.['serverError'] }}
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-label">{{ 'phone'|translate }} <span class="text-danger">*</span></label>
                <input class="form-control form-control-sm" type="number" placeholder="Ex. 677777777" formControlName="phone" [ngClass]="{'is-invalid': fc['phone'].invalid && isSubmitted}">
                <small class="invalid-feedback fst-italic" *ngIf="fc['phone'].errors?.['required']">{{ 'this field is required'|translate }}</small>
                <div class="invalid-feedback" *ngIf="fc['phone'].errors?.['pattern']">{{ 'phone must between 1 - 9'|translate }}</div>
                <div class="invalid-feedback" *ngIf="fc['phone'].errors?.['serverError']">
                  {{ fc['phone'].errors?.['serverError'] }}
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <label class="form-label">{{ 'username'|translate }} <span class="text-danger">*</span></label>
                <input class="form-control form-control-sm" type="text" placeholder="Ex. Jdoe" formControlName="username" [ngClass]="{'is-invalid': fc['username'].invalid && isSubmitted}">
                <small class="invalid-feedback fst-italic" *ngIf="fc['username'].errors?.['required']">{{ 'this field is required'|translate }}</small>
                <div class="invalid-feedback" *ngIf="fc['username'].errors?.['serverError']">
                  {{ fc['username'].errors?.['serverError'] }}
                </div>
              </div>
              <div class="col-md-8">
                <label class="form-label">{{ 'email'|translate }} <span class="text-danger">*</span></label>
                <input class="form-control form-control-sm" type="text" placeholder="Ex. jdoe@bp.com" formControlName="email" [ngClass]="{'is-invalid': fc['email'].invalid && isSubmitted}">
                <small class="invalid-feedback fst-italic" *ngIf="fc['email'].errors?.['required']">{{ 'this field is required'|translate }}</small>
                <small class="invalid-feedback fst-italic" *ngIf="fc['email'].errors?.['email']">{{ 'email must be respect mail convention'|translate }}</small>
                <div class="invalid-feedback" *ngIf="fc['email'].errors?.['serverError']">
                  {{ fc['email'].errors?.['serverError'] }}
                </div>
              </div>

            </div>

          </div>
          <div class="card-footer text-end">

            <button form="ngForm" (submit)="onFormSubmit()" type="submit" class="btn btn-sm btn-primary m-r-10">
              <i class="fa fa-save" *ngIf="!saving; else isSaving" style="margin-right: 5px;"></i>
              <ng-template #isSaving>
                <i class="fa fa-spin fa-spinner me-2"></i>
              </ng-template>
              {{ 'update'|translate }}
            </button>

          </div>
        </div>
      </div>

    </form>
  </div>
</div>